import React, { useState } from 'react';
import cn from 'classnames';
import PropTypes, { array } from 'prop-types';
import { useTranslation } from 'react-i18next';

import {
  EmptyState,
  Loading,
  Table
} from 'components/common/Elements/Elements';
import { cohortChurnConf } from '../helpers/configurates';
import { textToDateMY } from 'utils/common';
import { cohortCount, percentToColor } from 'utils/cohorts';

import classes from './CohortTable.module.scss';

const CohortTable = ({ tableData = [], unit, loader }) => {
  const { t } = useTranslation(['activity']);
  const [row, setRow] = useState('');

  const mouseEnter = e => {
    setRow(e.currentTarget.getAttribute('r'));
  };
  const mouseLeave = () => {
    setRow('');
  };

  return (
    <div className={classes.outer}>
      <div className={classes.inner}>
        <Table className={classes.table}>
          <Table.Header>
            <Table.Row withBorder={false}>
              {cohortChurnConf.map(({ field, title }, ind) => (
                <Table.HeaderCell
                  key={field}
                  className={classes.header}
                  onMouseEnter={mouseEnter}
                  onMouseLeave={mouseLeave}
                  r={`r${ind}`}
                  title={title}
                />
              ))}
              {cohortCount.map(({ title }, ind) => (
                <Table.HeaderCell
                  key={title}
                  className={classes.header}
                  onMouseEnter={mouseEnter}
                  onMouseLeave={mouseLeave}
                  r={`r${ind}`}
                  title={title}
                  classNameTitle={classes.header_fixed}
                />
              ))}
            </Table.Row>
          </Table.Header>
          {loader || tableData.length === 0 ? (
            <Table.Body></Table.Body>
          ) : (
            <Table.Body>
              {tableData.map(rowData => (
                <Table.Row key={rowData[0]} className={classes.row}>
                  {rowData.map((cellData, ind) =>
                    ind !== 0 ? (
                      <Table.Cell
                        key={`cell-${ind}-${cellData}`}
                        className={cn(
                          classes.cell,
                          percentToColor(
                            cellData['cohortNumOfCustomers'],
                            classes
                          ),
                          row === `r${ind}` && classes.hov
                        )}
                        onMouseEnter={mouseEnter}
                        r={`r${ind}`}
                        classNameContent={classes.center}
                      >
                        {unit === t('activity:units.PERCENT')
                          ? `${cellData['cohortNumOfCustomers']}${t(
                              'activity:units.PERCENT'
                            )}`
                          : cellData['numOfCustomers']}
                      </Table.Cell>
                    ) : (
                      <Table.Cell
                        key={`cell-${ind}-${cellData}`}
                        className={classes.cell}
                        onMouseEnter={mouseEnter}
                        r={`r${ind}`}
                      >
                        {textToDateMY(cellData)}
                      </Table.Cell>
                    )
                  )}
                </Table.Row>
              ))}
            </Table.Body>
          )}
        </Table>
      </div>
      {tableData.length === 0 && <EmptyState />}
      {loader && <Loading />}
    </div>
  );
};

CohortTable.propTypes = {
  tableData: PropTypes.arrayOf(array),
  loader: PropTypes.bool,
  unit: PropTypes.string
};

export default CohortTable;
